module.exports = "<div [@alertState]=\"alert.state\" class=\"alert {{ alert.level }}\">\n  <div class=\"alert-item\">\n            <span class=\"alert-text\">\n                {{ alert.message }}\n            </span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/alert/alert.component.html
// module id = 387
// module chunks = 1